import { combineReducers } from 'redux';

import byPage from './byPage/reducer';
import byKeyMaker from 'reducersMakers/byKeyMaker';

export default byKeyMaker('threadId', combineReducers({ byPage }));



/** WEBPACK FOOTER **
 ** ./src/members/state/mail/mailThreadMessages/byThreadId/reducer.js
 **/